import { __constants } from "../../constants"
import axios from "axios"
const BASE_URL = process.env.REACT_APP_SERVER_URL

const authHeaders = () => ({
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
  },
})

// Get the screenshot/link the housekeeper submitted at signup (admin-only reference material)
export const getExternalReviewProofController = async (userId) => {
  try {
    const response = await axios.get(`${BASE_URL}/v1/admin/user-management/external-review/proof/${userId}`, authHeaders())
    return response
  } catch (error) {
    console.error("Error in getExternalReviewProofController:", error)
    return error.response
  }
}

// Add a new external review (not tied to a submitted screenshot/link)
export const addExternalReviewController = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/v1/admin/user-management/external-review`, data, authHeaders())
    return response
  } catch (error) {
    console.error("Error in addExternalReviewController:", error)
    return error.response
  }
}

// Approve a submitted screenshot/link — writes the review text for it and marks it Approved
export const approveExternalReviewItemController = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/v1/admin/user-management/external-review/approve-item`, data, authHeaders())
    return response
  } catch (error) {
    console.error("Error in approveExternalReviewItemController:", error)
    return error.response
  }
}

// Edit an existing external review
export const editExternalReviewController = async (id, data) => {
  try {
    const response = await axios.put(`${BASE_URL}/v1/admin/user-management/external-review/${id}`, data, authHeaders())
    return response
  } catch (error) {
    console.error("Error in editExternalReviewController:", error)
    return error.response
  }
}

// Delete an external review
export const deleteExternalReviewController = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/v1/admin/user-management/external-review/${id}`, authHeaders())
    return response
  } catch (error) {
    console.error("Error in deleteExternalReviewController:", error)
    return error.response
  }
}
